


























































































import {Vue, Component} from 'vue-property-decorator'
import {TrosakVozila} from "@/services/BackendProxies";
import dataProxy from "@/services/data-proxy.service";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class VrsteTroskovaVozila extends mixins(ComponentBaseMixin) {
    columns = [];
    vrsteTroskova = [];
    trosakVozila = new TrosakVozila();
    tableOptions = {
        search: true,
        pagination: true,
        onClickRow: row => this.onClickRow(row)
    };


    async created() {
        this.columns = [
            {field: 'naziv', title: this.$i18n.t('naziv')},
            {field: 'vrstaOdrzavanja', width: 100, title: this.$i18n.t('vrstaOdrzavanja')}
        ];
        this.vrsteTroskova = await this.loadData(() => dataProxy.vratiTroskoveVozila())();
    }

    async sacuvajVrstuTroskova() {
        const isValid = await (<any>this.$refs.form).validate();
        if (isValid) {
            this.trosakVozila = await this.saveData(() => dataProxy.sacuvajTrosakVozila(this.trosakVozila))();
            this.vrsteTroskova = await this.loadData(() => dataProxy.vratiTroskoveVozila())();
        }
    }

    async obrisiVrstuTroskova() {
        const isValid = await this.confirmationNeeded('da li zelite da obrisete trosak vozila');
        if (isValid) {
            this.vrsteTroskova = await this.deleteData(() => dataProxy.obrisiTrosakVozila(this.trosakVozila.id))();
            this.novaVrstaTroskova();
        }
    }

    novaVrstaTroskova() {
        this.trosakVozila = new TrosakVozila();
        (<HTMLElement>this.$refs.naziv).focus();
    }

    onClickRow(row) {
        this.trosakVozila = row;
    }
}
